export const disclaimerUrl = {
  privacyPolicy: 'privacy-policies',
  termsAndConditions: 'terms-and-conditions',
  userAgreement: 'user-agreements',
  faq: 'faqs',
};
